export const WS_MESSAGE = 'WS_MESSAGE';
export const GET_DASHBOARD = 'GET_DASHBOARD';
